import { useNavigate, useParams } from 'react-router-dom';
import { EnvelopeIcon, PhoneIcon, TrashIcon } from '@heroicons/react/20/solid';
import React, { useEffect, useState } from 'react';
import formatDate from '../../utils/formatDate';
import client from '../../api/client';
import { useAlert } from '../../context/AlertContext';

export default function MessageCard({}) {
	const { id } = useParams();
	const [message, setMessage] = useState({});
	const { setAlert } = useAlert();
	const navigate = useNavigate();
	const fetchMessage = async () => {
		try {
			const { data } = await client.get(`/message/${id}`);
			setMessage(data.message);
		} catch (error) {
			console.error(error);
			setAlert('error', 'Error fetching message');
		}
	};
	const handleDelete = async (id) => {
		const { data } = await client.delete(`/message/${id}`);
		console.log({ data });
		navigate('/admin/messages');
	};
	useEffect(() => {
		if (id) fetchMessage();
	}, [id]);

	return (
		<div className='container max-w-md col-span-1 divide-y divide-gray-200 rounded-lg  shadow-xl h-full bg-gray-400'>
			<div className='flex flex-col p-6'>
				<h3 className='text-lg font-semibold text-gray-900'>
					{message.name || 'No Name'}
				</h3>
				<p className='text-sm text-gray-500 mt-2'>
					{formatDate(message?.createdAt) || 'Date not available'}
				</p>
				<div className='mt-4 space-y-2'>
					{[
						{
							label: 'Phone',
							value:
								message?.phone ||
								message?.customer?.phone ||
								'No phone number provided',
						},
						{
							label: 'Email',
							value:
								message?.email ||
								message?.customer?.email ||
								'No email provided',
						},
						{
							label: 'Message',
							value: message?.message || 'No message provided',
						},
					].map((item, index) => (
						<div
							key={index}
							className='flex items-center'
						>
							<p className='text-sm text-gray-600'>{item.label}:</p>
							<p className='ml-2 text-sm text-gray-800'>{item.value}</p>
						</div>
					))}
				</div>
			</div>
			<div className='flex divide-x divide-gray-200'>
				<a
					href={`mailto:${message?.email}`}
					className='flex-1 py-4 text-sm font-medium text-center text-gray-600 hover:bg-gray-100 flex items-center justify-center gap-2'
				>
					<EnvelopeIcon
						className='h-5 w-5 text-gray-400'
						aria-hidden='true'
					/>
					Email
				</a>
				<a
					href={`tel:${message?.phone}`}
					className='flex-1 py-4 text-sm font-medium text-center text-gray-600 hover:bg-gray-100 flex items-center justify-center gap-2'
				>
					<PhoneIcon
						className='h-5 w-5 text-gray-400'
						aria-hidden='true'
					/>
					Call
				</a>
				<button
					onClick={() => handleDelete(message?._id)}
					className='flex-1 py-4 text-sm font-medium text-center text-red-600 hover:bg-red-50 flex items-center justify-center gap-2'
				>
					<TrashIcon
						className='h-5 w-5 text-red-400'
						aria-hidden='true'
					/>
					Delete
				</button>
			</div>
		</div>
	);
}
